import { MantineThemeOverride } from '@mantine/core';

export type SimpleGridTheme = NonNullable<MantineThemeOverride['components']>['SimpleGrid'];

export const SimpleGrid: SimpleGridTheme = {
  // todo: define
};
